/* eslint-disable */
export const translations = {
  fr: {
    nav: {
      home: 'Accueil', about: 'À propos', trading: 'Trading', platform: 'Plateforme',
      partnership: 'Partenariat', team: 'Équipe', experience: 'Expérience', contact: 'Contact',
    },
    cta: { quote: 'Obtenir un Devis', getInTouch: 'Nous Contacter', discover: 'Découvrir nos Services' },
    hero: {
      badge: 'Commerce International • Depuis 2023',
      subtitle: "Société canadienne de {highlight} et plateforme industrielle connectée aux plus grands manufacturiers chinois. Nous accompagnons producteurs, distributeurs et entrepreneurs à travers deux services distincts.",
      highlight: 'trading de matières premières',
      service1Tag: 'Service 01', service1Title: 'Trading de Matières Premières',
      service1Desc: 'Voir les cours',
      service2Tag: 'Service 02', service2Title: 'Plateforme Industrielle',
      service2Desc: 'Missions, partenaires, produits rescapés et 16 catégories',
      discover: 'Découvrir', explore: 'Explorer',
    },
    about: {
      label: 'À propos', title1: 'Bienvenue chez', title2: 'Yuville International inc.',
      p1: 'Entité canadienne de trading spécialisée dans l’approvisionnement et la distribution de matières premières : cuivre, aluminium, or, bitume, soufre, potasse et bien plus. Nous sommes des traders physiques, négociant et sécurisant de grandes quantités pour nos associés et clients en Chine.',
      p2: 'Nous sommes également membres d’un réseau privé qui nous donne un accès exclusif aux manufacturiers et industriels chinois. Trouver des produits, des partenaires et organiser des missions commerciales est notre spécialité.',
      stat1: 'Manufacturiers partenaires', stat2: 'Catégories de marchandises', stat3: 'Matières premières négociées',
      foundedIn: 'Fondée en 2023',
    },
    trading: {
      badge: 'Service 01 • Trading', title1: 'Trading de', title2: 'Matières Premières',
      intro: 'Producteurs de cuivre, d’aluminium, de soufre, de potasse et autres matières premières : rejoignez notre réseau et déposez votre offre. Nous connectons vos produits aux plus grands acheteurs chinois.',
      whyTitle: 'Travailler avec Yuville',
      benefits: [
        { t: 'Accès direct au marché chinois', d: 'Nos acheteurs cherchent activement du volume de qualité, sans intermédiaires.' },
        { t: 'Négociation transparente', d: 'Prix justes, contrats clairs et paiements sécurisés.' },
        { t: 'Logistique et documentation', d: 'Nous pouvons gérer toute la logistique : inspection, douane et expédition internationale.' },
        { t: 'Traders physiques', d: 'Achat ferme ou mandat d’achat — vous choisissez le modèle.' },
      ],
      producerBox: 'Producteur ?',
      producerBoxDesc: 'Remplissez le formulaire ci-contre pour déposer une offre confidentielle. Notre équipe vous contactera sous 48 heures.',
      formTitle: 'Déposer une offre', formSubtitle: 'Inscription rapide pour producteurs et fournisseurs.',
      fCompany: 'Entreprise *', fCompanyPh: 'Nom de votre société',
      fName: 'Nom du contact', fNamePh: 'Jean Dupont',
      fEmail: 'Email *', fEmailPh: 'contact@entreprise.com',
      fCountry: 'Pays', fCountryPh: 'Canada',
      fCommodity: 'Matière',
      fQuantity: 'Quantité disponible *', fQuantityPh: 'Ex: 5000 tonnes / mois',
      fMessage: 'Détails de l’offre', fMessagePh: 'Qualité, spécifications, Incoterms, prix indicatif...',
      submit: 'Soumettre l’offre',
      confidential: '🔒 Vos informations restent strictement confidentielles.',
      required: 'Champs requis', requiredDesc: 'Merci de remplir les champs obligatoires.',
      thanksTitle: 'Offre reçue !', thanksDesc: 'Notre équipe vous contactera sous 48h.',
      errorTitle: 'Erreur', errorDesc: 'Impossible d\'envoyer l\'offre. Réessayez.',
      strongDemand: 'Forte demande', stableDemand: 'Demande stable', growingDemand: 'Demande croissante',
      other: 'Autre',
      commodityDescs: {
        cuivre: 'Cathodes, concentrés et minerais de cuivre pour l’industrie mondiale.',
        aluminium: 'Lingots et alliages d’aluminium destinés aux manufacturiers.',
        soufre: 'Soufre granulé et formé pour applications industrielles et agricoles.',
        potasse: 'Chlorure de potassium pour engrais et industries chimiques.',
        bitume: 'Bitume de qualité routière et industrielle.',
        or: 'Lingots d’or certifiés pour investisseurs et clients institutionnels.',
      },
      unitTonne: 'USD / tonne', unitOunce: 'USD / once',
      names: { cuivre: 'Cuivre', aluminium: 'Aluminium', soufre: 'Soufre', potasse: 'Potasse', bitume: 'Bitume', or: 'Or' },
    },
    platform: {
      label: 'Service 02', title1: 'Plateforme', title2: 'Industrielle',
      intro: 'Cinq services pensés pour les entrepreneurs, distributeurs et manufacturiers qui souhaitent tisser des liens durables avec le marché chinois.',
      services: {
        missions: {
          title: 'Missions Commerciales',
          desc: 'Organisation complète de missions commerciales en Chine : rencontres B2B, visites d’usines, négociations et suivi post-mission.',
          highlights: ['Agenda personnalisé', 'Interprète bilingue', "Visites d'usines", 'Suivi post-mission'],
        },
        partenaires: {
          title: 'Recherche de produits',
          desc: "Identification et validation de partenaires industriels ou de manufacturiers chinois qualifiés selon vos critères précis.",
          highlights: ['Vérification légale', 'Audit qualité', 'Négociation contrats', 'Accompagnement long terme'],
        },
        rescapes: {
          title: 'Produits Rescapés',
          desc: 'Biens de consommation retenus en douane, invendus ou non payés, disponibles à prix avantageux pour distributeurs et consommateurs.',
          highlights: ['Prix négociés', 'Lots disponibles', 'Livraison rapide', 'Traçabilité complète'],
        },
        marchandises: {
          title: 'Diverses Marchandises',
          desc: 'Plus de 16 catégories de marchandises disponibles pour distributeurs, détaillants et grossistes à travers le Canada.',
          highlights: ['16 catégories', 'Import direct', 'Volumes flexibles', 'Support logistique'],
        },
        entreprises: {
          title: 'Entreprises du Mois',
          desc: 'Chaque mois, présentation de deux entreprises chinoises sélectionnées et de leurs gammes de produits phares.',
          highlights: ['Sélection mensuelle', 'Fiches détaillées', 'Contact direct', 'Échantillons possibles'],
        },
      },
      missionsHeading: 'Prochaines missions en Chine',
      missionsBook: 'Réserver ma place',
      partnersHeading: 'Notre processus en 4 étapes',
      partnersSteps: [
        { n: '01', t: 'Cahier des charges', d: 'Analyse précise de votre besoin.' },
        { n: '02', t: 'Short-list', d: 'Sélection de manufacturiers qualifiés — chaque candidat évalué sur sa capacité, sa conformité, ses certifications et son expérience.' },
        { n: '03', t: 'Audit sur place', d: 'Vérification de l\'usine, du produit et de la conformité — rapport documenté avec preuves et écarts identifiés.' },
        { n: '04', t: 'Contrat & suivi', d: 'Négociation et accompagnement long terme.' },
      ],
      shortlistIntro: {
        title: '02 — Short-list · Sélection de manufacturiers qualifiés',
        p1: "À partir de votre cahier des charges, Yuville recherche et présélectionne les manufacturiers capables de répondre à vos exigences.",
        p2: "Nous évaluons notamment leur capacité de production, leur conformité à vos spécifications, leurs certifications, leur expérience, leurs conditions commerciales et leur capacité à desservir votre marché.",
        p3: "Nous vous présentons ensuite une short-list comparative afin d'identifier avec vous les manufacturiers qui méritent d'être approfondis.",
      },
      auditIntro: {
        title: '03 — Audit sur place · Vérification de l\'usine, du produit et de la conformité',
        p1: "Les manufacturiers retenus font l'objet d'une vérification approfondie avant tout engagement contractuel. Nous vérifions sur place les installations et capacités de production, la conformité du produit à votre cahier des charges ainsi que les principaux éléments juridiques et commerciaux de l'entreprise.",
        p2: "Vous recevez un rapport d'audit documenté identifiant les éléments vérifiés, les écarts constatés et les points devant être résolus avant la contractualisation.",
      },
      rfq: {
        cta: 'Définir mon besoin',
        openHint: 'Commencez ici votre cahier des charges — nous nous occupons du reste.',
        dialogTitle: 'Définissons votre besoin',
        intro: "Décrivez-nous le produit, l'équipement ou la solution industrielle que vous recherchez. Ces informations nous permettront de préciser votre cahier des charges et d'identifier les fabricants susceptibles de répondre à vos exigences.",
        s1: '1. Quel est votre projet ?',
        s1Sub: 'Choisissez ce qui décrit le mieux votre besoin.',
        pt: {
          manufacturer: 'Trouver un fabricant en Chine',
          custom: 'Faire fabriquer un produit selon mes spécifications',
          product: 'Trouver un produit existant',
          equipment: 'Trouver une solution ou un équipement industriel',
          partner: 'Trouver un partenaire commercial ou industriel',
          other: 'Autre',
        },
        ptOtherLabel: 'Précisez votre projet',
        s2: '2. Votre besoin',
        f: {
          product: 'Produit ou équipement recherché',
          productPh: 'Ex. : disjoncteurs haute tension, robots collaboratifs, textiles techniques…',
          desc: 'Description du besoin',
          descPh: 'Expliquez librement le contexte, les usages, les contraintes, l\'environnement…',
          qty: 'Quantité estimée',
          qtyPh: 'Nombre',
          unit: 'Unité',
          unitPh: 'unités, kg, tonnes, m², palettes…',
          freq: 'Fréquence du besoin',
          budget: 'Budget ou prix cible (facultatif)',
          budgetPh: 'Montant',
          currency: 'Devise',
          market: 'Marché de destination',
          marketPh: 'Pays ou région où le produit sera utilisé ou revendu',
          standards: 'Normes ou certifications requises',
          standardsPh: 'CSA, UL, CE, ISO 9001, FDA, Santé Canada…',
          custom: 'Personnalisation requise ?',
          customYes: 'Oui', customNo: 'Non',
          customDetails: 'Décrivez la personnalisation recherchée',
          customDetailsPh: 'Dimensions, couleurs, logo, matériaux, tension, packaging…',
          timeline: 'Échéancier souhaité',
          timelinePh: 'Ex. : livraison souhaitée avant juin 2026',
        },
        freq: {
          once: 'Commande unique',
          monthly: 'Mensuelle',
          quarterly: 'Trimestrielle',
          yearly: 'Annuelle',
          tbd: 'À déterminer',
        },
        s3: '3. Documents et références',
        s3Sub: 'Joignez photos, plans, devis, fiches techniques ou tout document utile.',
        filesLabel: 'Ajouter des fichiers',
        filesHint: 'PDF, DOC, XLS, images, DWG, STEP, ZIP • max 8 fichiers, 15 Mo chacun',
        filesEmpty: 'Aucun fichier ajouté',
        refUrl: 'Lien vers un produit ou une référence (facultatif)',
        refUrlPh: 'https://…',
        s4: '4. Coordonnées',
        c: {
          name: 'Nom', company: 'Entreprise', role: 'Fonction', country: 'Pays',
          email: 'Courriel professionnel', phone: 'Téléphone', website: 'Site Web de l\'entreprise (facultatif)',
        },
        submit: 'Soumettre mon cahier des charges',
        submitting: 'Envoi en cours…',
        required: 'Champ obligatoire',
        okTitle: 'Votre demande a été transmise',
        okBody: "Notre équipe examinera les informations fournies et communiquera avec vous afin de préciser, au besoin, votre cahier des charges avant d'entreprendre la recherche de fabricants.",
        okClose: 'Fermer',
        errTitle: 'Erreur d\'envoi',
        errBody: 'Merci de vérifier les champs obligatoires et de réessayer.',
        errFile: 'Fichier non accepté :',
        cancel: 'Annuler',
      },
      rescuedHeading: 'Lots disponibles cette semaine',
      rescuedNote: 'Marchandise retenue en douane, invendue ou non payée — disponible pour distributeurs et consommateurs à prix avantageux.',
      merchHeading: '16 catégories disponibles',
      merchSubtitle: 'Un catalogue diversifié sourcé auprès des manufacturiers partenaires.',
      companiesHeading: 'Entreprises chinoises du mois',
      founded: 'Fondée en',
      productCategories: [
        'Électronique','Textiles & Vêtements','Électroménager','Outillage industriel','Équipements de sécurité','Mobilier & Décoration',
        'Jouets & Loisirs','Cosmétiques','Articles ménagers','Pièces automobiles','Équipement médical','Fournitures de bureau',
        'Éclairage & LED','Sports & Plein air','Emballage industriel','Machinerie légère',
      ],
      missionsList: [
        { city: 'Shenzhen', date: '15–22 Nov 2025', focus: 'Électronique & IoT' },
        { city: 'Guangzhou', date: '10–17 Fév 2026', focus: 'Textiles & Mode' },
        { city: 'Shanghai', date: '5–12 Avr 2026', focus: 'Machinerie industrielle' },
      ],
    },
    partnership: {
      label: 'Partenariat Chinois', title1: 'Actionnaires de', title2: 'Qianyan Holdings',
      badgeLeft: 'Partenaire stratégique',
      subtitle: 'Shenzhen, Chine · Société de trading',
      floating1: 'Actionnaire', floating2: 'Yuville International inc.',
      body: 'Yuville International inc. est fière d’être actionnaire de {strong}, une société de trading chinoise établie à Shenzhen. Ce partenariat stratégique nous donne un ancrage direct sur le marché chinois et un accès privilégié à un vaste réseau de manufacturiers, d’acheteurs et de distributeurs.',
      bodyStrong: 'Qianyan Holdings (Shenzhen) Group Co. Ltd.',
      benefits: [
        { t: 'Relation d’affaires directe', d: 'Aucun intermédiaire — négociation directe avec les acteurs chinois majeurs.' },
        { t: 'Présence locale à Shenzhen', d: 'Une équipe sur place au cœur du hub industriel et logistique du sud de la Chine.' },
        { t: 'Portefeuille diversifié', d: 'Trading de matières premières, sourcing industriel et distribution.' },
      ],
      visit: 'Visiter qianyanholding.com',
    },
    whyUs: {
      label: 'Pourquoi Nous', title1: 'Choisir', title2: 'Yuville',
      intro: 'Notre force réside dans un réseau exclusif de manufacturiers chinois combiné à une expertise canadienne en trading de matières premières.',
      items: [
        { t: 'Excellence Transparente', d: 'Une approche directe, honnête et transparente dans toutes nos transactions commerciales.' },
        { t: 'Sourcing Efficace', d: 'Expertise dans le sourcing rapide de matières premières difficiles à trouver pour nos clients.' },
        { t: 'Partenaire Fiable', d: 'Un accompagnement personnalisé et une relation de confiance sur le long terme.' },
        { t: 'Réseau Chinois Exclusif', d: 'Accès privilégié à des milliers de manufacturiers chinois leaders dans leur industrie.' },
      ],
    },
    team: {
      label: 'Notre Équipe', title1: 'Rencontrez', title2: 'l’équipe',
      members: [
        { name: 'Denis Villeneuve', role: 'Président et Fondateur', bio: "Longue expérience en financement d'entreprises, production pour le cinéma et la télévision, en commerce international et négociations de matières premières et d'instruments médicaux." },
        { name: 'Jimmy Changtao Yu', role: 'Vice-Président et Fondateur', bio: 'Co-fondateur de Yuville, il dirige la stratégie de développement et les relations avec le marché chinois.' },
        { name: 'Yan Yu', role: 'Directeur Plateforme Chinoise', bio: 'Gestionnaire de la plateforme reliant les manufacturiers chinois aux entreprises canadiennes. Vaste expérience en ventes, marketing et entrepreneuriat.' },
      ],
    },
    contact: {
      label: 'Contact', title1: 'Entrons en', title2: 'contact',
      intro: 'Une question sur le trading ou la plateforme industrielle ? Notre équipe est disponible pour vous répondre en français, anglais ou mandarin.',
      lEmail: 'Email', lPhone: 'Téléphone', lOfficeCA: 'Bureau Canadien', lOfficeCN: 'Bureau Chinois',
      officeCAValue: '1155 Metcalfe, Suite 1571-2, Montréal, Québec H3B 2V6, Canada', officeCNValue: 'Shenzhen, Guangdong, Chine',
      viaQianyan: 'via Qianyan Holdings Group ↗',
      formTitle: 'Envoyez-nous un message',
      name: 'Nom', email: 'Email *', subject: 'Sujet', message: 'Votre message *',
      send: 'Envoyer', sending: 'Envoi…',
      missingTitle: 'Champs manquants', missingDesc: 'Email et message sont requis.',
      sentTitle: 'Message envoyé', sentDesc: 'Nous vous répondrons rapidement.',
      errorTitle: 'Erreur', errorDesc: 'Impossible d\'envoyer le message.',
    },
    footer: {
      tagline: 'Société canadienne de trading de matières premières et plateforme industrielle connectée aux plus grands manufacturiers chinois.',
      shareholderOf: 'Actionnaire de',
      services: 'Services',
      s1: 'Trading Matières Premières', s2: 'Missions Commerciales', s3: 'Recherche Partenaires', s4: 'Produits Rescapés', s5: 'Entreprises du Mois',
      company: 'Entreprise', c1: 'À propos', c2: 'Partenariat Qianyan', c3: 'Équipe', c4: 'Contact',
      rights: 'Tous droits réservés.',
      cities: 'Montréal, Canada · Shenzhen, Chine',
    },
  },

  en: {
    nav: {
      home: 'Home', about: 'About', trading: 'Trading', platform: 'Platform',
      partnership: 'Partnership', team: 'Team', experience: 'Experience', contact: 'Contact',
    },
    cta: { quote: 'Get a Quote', getInTouch: 'Get in Touch', discover: 'Discover Our Services' },
    hero: {
      badge: 'International Trade • Since 2023',
      subtitle: 'Canadian {highlight} company and industrial platform connected to the largest Chinese manufacturers. We support producers, distributors and entrepreneurs through two distinct services.',
      highlight: 'commodity trading',
      service1Tag: 'Service 01', service1Title: 'Commodity Trading',
      service1Desc: 'View live prices',
      service2Tag: 'Service 02', service2Title: 'Industrial Platform',
      service2Desc: 'Trade missions, partners, rescued products and 16 categories',
      discover: 'Discover', explore: 'Explore',
    },
    about: {
      label: 'About', title1: 'Welcome to', title2: 'Yuville International inc.',
      p1: 'A Canadian trading entity specialized in the sourcing and distribution of raw materials: copper, aluminum, gold, bitumen, sulfur, potash and much more. We are physical traders, negotiating and securing large quantities for our associates and clients in China.',
      p2: "We are also members of a private network that gives us exclusive access to Chinese manufacturers and industrial players. Sourcing products, finding partners and organizing trade missions is our specialty.",
      stat1: 'Manufacturing partners', stat2: 'Merchandise categories', stat3: 'Commodities traded',
      foundedIn: 'Founded in 2023',
    },
    trading: {
      badge: 'Service 01 • Trading', title1: 'Commodity', title2: 'Trading',
      intro: 'Producers of copper, aluminum, sulfur, potash and other commodities: join our network and submit your offer. We connect your products to the largest Chinese buyers.',
      whyTitle: 'Working with Yuville',
      benefits: [
        { t: 'Direct access to the Chinese market', d: 'Our buyers are actively looking for quality volume, no middlemen.' },
        { t: 'Transparent negotiation', d: 'Fair prices, clear contracts and secure payments.' },
        { t: 'Logistics & documentation', d: 'We can handle all the logistics: inspection, customs and international shipping.' },
        { t: 'Physical traders', d: 'Firm purchase or buying mandate — you choose the model.' },
      ],
      producerBox: 'Are you a producer?',
      producerBoxDesc: 'Fill in the form to submit a confidential offer. Our team will contact you within 48 hours.',
      formTitle: 'Submit an offer', formSubtitle: 'Quick registration for producers and suppliers.',
      fCompany: 'Company *', fCompanyPh: 'Your company name',
      fName: 'Contact name', fNamePh: 'John Doe',
      fEmail: 'Email *', fEmailPh: 'contact@company.com',
      fCountry: 'Country', fCountryPh: 'Canada',
      fCommodity: 'Commodity',
      fQuantity: 'Available quantity *', fQuantityPh: 'Ex: 5000 tons / month',
      fMessage: 'Offer details', fMessagePh: 'Quality, specifications, Incoterms, indicative price...',
      submit: 'Submit offer',
      confidential: '🔒 Your information remains strictly confidential.',
      required: 'Required fields', requiredDesc: 'Please fill in the required fields.',
      thanksTitle: 'Offer received!', thanksDesc: 'Our team will contact you within 48h.',
      errorTitle: 'Error', errorDesc: 'Unable to send the offer. Please retry.',
      strongDemand: 'Strong demand', stableDemand: 'Stable demand', growingDemand: 'Growing demand',
      other: 'Other',
      commodityDescs: {
        cuivre: 'Copper cathodes, concentrates and ores for global industry.',
        aluminium: 'Aluminum ingots and alloys for manufacturers.',
        soufre: 'Granular and formed sulfur for industrial and agricultural use.',
        potasse: 'Potassium chloride for fertilizers and chemical industries.',
        bitume: 'Road-grade and industrial bitumen.',
        or: 'Certified gold bars for investors and institutional clients.',
      },
      unitTonne: 'USD / ton', unitOunce: 'USD / ounce',
      names: { cuivre: 'Copper', aluminium: 'Aluminum', soufre: 'Sulfur', potasse: 'Potash', bitume: 'Bitumen', or: 'Gold' },
    },
    platform: {
      label: 'Service 02', title1: 'Industrial', title2: 'Platform',
      intro: 'Five services designed for entrepreneurs, distributors and manufacturers who want to build lasting ties with the Chinese market.',
      services: {
        missions: {
          title: 'Trade Missions',
          desc: 'Complete organization of trade missions to China: B2B meetings, factory visits, negotiations and post-mission follow-up.',
          highlights: ['Custom agenda', 'Bilingual interpreter', 'Factory visits', 'Post-mission follow-up'],
        },
        partenaires: {
          title: 'Product Sourcing',
          desc: 'Identification and validation of qualified industrial partners or Chinese manufacturers based on your precise criteria.',
          highlights: ['Legal verification', 'Quality audit', 'Contract negotiation', 'Long-term support'],
        },
        rescapes: {
          title: 'Rescued Products',
          desc: 'Consumer goods held at customs, unsold or unpaid, available at attractive prices for distributors and consumers.',
          highlights: ['Negotiated prices', 'Available lots', 'Fast delivery', 'Full traceability'],
        },
        marchandises: {
          title: 'Various Merchandise',
          desc: 'Over 16 categories of merchandise available for distributors, retailers and wholesalers across Canada.',
          highlights: ['16 categories', 'Direct import', 'Flexible volumes', 'Logistics support'],
        },
        entreprises: {
          title: 'Companies of the Month',
          desc: 'Every month, presentation of two selected Chinese companies and their flagship product lines.',
          highlights: ['Monthly selection', 'Detailed profiles', 'Direct contact', 'Samples possible'],
        },
      },
      missionsHeading: 'Upcoming missions in China',
      missionsBook: 'Book my seat',
      partnersHeading: 'Our 4-step process',
      partnersSteps: [
        { n: '01', t: 'Requirements', d: 'Precise analysis of your needs.' },
        { n: '02', t: 'Short-list', d: 'Selection of qualified manufacturers — each candidate evaluated on capacity, compliance, certifications and experience.' },
        { n: '03', t: 'On-site audit', d: 'Verification of the factory, the product and the compliance — documented report with evidence and identified gaps.' },
        { n: '04', t: 'Contract & follow-up', d: 'Negotiation and long-term support.' },
      ],
      shortlistIntro: {
        title: '02 — Short-list · Selection of qualified manufacturers',
        p1: 'Based on your specifications, Yuville researches and pre-selects the manufacturers able to meet your requirements.',
        p2: 'We assess their production capacity, compliance with your specifications, certifications, experience, commercial terms and ability to serve your market.',
        p3: 'We then present you with a comparative short-list so we can identify together which manufacturers deserve deeper investigation.',
      },
      auditIntro: {
        title: '03 — On-site audit · Verification of the factory, product and compliance',
        p1: 'Retained manufacturers undergo an in-depth verification before any contractual commitment. We check on-site the facilities and production capacity, the product\'s compliance with your specifications and the main legal and commercial aspects of the company.',
        p2: 'You receive a documented audit report identifying what was verified, the gaps observed and the items to be resolved before contracting.',
      },
      rfq: {
        cta: 'Define my needs',
        openHint: 'Start your specifications here — we take care of the rest.',
        dialogTitle: "Let's define your needs",
        intro: 'Tell us about the product, equipment or industrial solution you are looking for. This information will let us refine your specifications and identify manufacturers able to meet your requirements.',
        s1: '1. What is your project?',
        s1Sub: 'Pick the option that best describes your need.',
        pt: {
          manufacturer: 'Find a manufacturer in China',
          custom: 'Have a product made to my specifications',
          product: 'Find an existing product',
          equipment: 'Find an industrial solution or equipment',
          partner: 'Find a commercial or industrial partner',
          other: 'Other',
        },
        ptOtherLabel: 'Please specify your project',
        s2: '2. Your need',
        f: {
          product: 'Product or equipment sought',
          productPh: 'e.g., high-voltage breakers, cobots, technical textiles…',
          desc: 'Description of the need',
          descPh: 'Describe context, uses, constraints, environment…',
          qty: 'Estimated quantity',
          qtyPh: 'Number',
          unit: 'Unit',
          unitPh: 'units, kg, tonnes, m², pallets…',
          freq: 'Frequency of need',
          budget: 'Budget or target price (optional)',
          budgetPh: 'Amount',
          currency: 'Currency',
          market: 'Destination market',
          marketPh: 'Country or region where the product will be used or resold',
          standards: 'Required standards or certifications',
          standardsPh: 'CSA, UL, CE, ISO 9001, FDA, Health Canada…',
          custom: 'Customization required?',
          customYes: 'Yes', customNo: 'No',
          customDetails: 'Describe the customization',
          customDetailsPh: 'Dimensions, colors, logo, materials, voltage, packaging…',
          timeline: 'Desired timeline',
          timelinePh: 'e.g., delivery expected by June 2026',
        },
        freq: {
          once: 'One-time order',
          monthly: 'Monthly',
          quarterly: 'Quarterly',
          yearly: 'Yearly',
          tbd: 'To be determined',
        },
        s3: '3. Documents and references',
        s3Sub: 'Attach photos, drawings, quotes, datasheets or any relevant file.',
        filesLabel: 'Add files',
        filesHint: 'PDF, DOC, XLS, images, DWG, STEP, ZIP • max 8 files, 15 MB each',
        filesEmpty: 'No file added',
        refUrl: 'Link to a product or reference (optional)',
        refUrlPh: 'https://…',
        s4: '4. Contact details',
        c: {
          name: 'Name', company: 'Company', role: 'Role', country: 'Country',
          email: 'Professional email', phone: 'Phone', website: 'Company website (optional)',
        },
        submit: 'Submit my specifications',
        submitting: 'Sending…',
        required: 'Required field',
        okTitle: 'Your request has been sent',
        okBody: 'Our team will review the information provided and get back to you to refine your specifications if needed, before we start the manufacturer search.',
        okClose: 'Close',
        errTitle: 'Submission error',
        errBody: 'Please check the required fields and try again.',
        errFile: 'File not accepted:',
        cancel: 'Cancel',
      },
      rescuedHeading: 'Lots available this week',
      rescuedNote: 'Merchandise held at customs, unsold or unpaid — available for distributors and consumers at attractive prices.',
      merchHeading: '16 available categories',
      merchSubtitle: 'A diversified catalog sourced from our partner manufacturers.',
      companiesHeading: 'Chinese companies of the month',
      founded: 'Founded in',
      productCategories: [
        'Electronics','Textiles & Apparel','Home Appliances','Industrial Tools','Safety Equipment','Furniture & Decor',
        'Toys & Leisure','Cosmetics','Household Items','Auto Parts','Medical Equipment','Office Supplies',
        'Lighting & LED','Sports & Outdoor','Industrial Packaging','Light Machinery',
      ],
      missionsList: [
        { city: 'Shenzhen', date: 'Nov 15–22, 2025', focus: 'Electronics & IoT' },
        { city: 'Guangzhou', date: 'Feb 10–17, 2026', focus: 'Textiles & Fashion' },
        { city: 'Shanghai', date: 'Apr 5–12, 2026', focus: 'Industrial Machinery' },
      ],
    },
    partnership: {
      label: 'Chinese Partnership', title1: 'Shareholders of', title2: 'Qianyan Holdings',
      badgeLeft: 'Strategic partner',
      subtitle: 'Shenzhen, China · Trading company',
      floating1: 'Shareholder', floating2: 'Yuville International inc.',
      body: 'Yuville International inc. is proud to be a shareholder of {strong}, a Chinese trading company based in Shenzhen. This strategic partnership gives us a direct foothold in the Chinese market and privileged access to a vast network of manufacturers, buyers and distributors.',
      bodyStrong: 'Qianyan Holdings (Shenzhen) Group Co. Ltd.',
      benefits: [
        { t: 'Direct business relationship', d: 'No middlemen — direct negotiation with major Chinese players.' },
        { t: 'Local presence in Shenzhen', d: 'A team on the ground at the heart of southern China’s industrial and logistics hub.' },
        { t: 'Diversified portfolio', d: 'Commodity trading, industrial sourcing and distribution.' },
      ],
      visit: 'Visit qianyanholding.com',
    },
    whyUs: {
      label: 'Why Us', title1: 'Choose', title2: 'Yuville',
      intro: 'Our strength lies in an exclusive network of Chinese manufacturers combined with Canadian expertise in commodity trading.',
      items: [
        { t: 'Transparent Excellence', d: 'A direct, honest and transparent approach in all our commercial transactions.' },
        { t: 'Efficient Sourcing', d: 'Expertise in quickly sourcing hard-to-find raw materials for our clients.' },
        { t: 'Reliable Partner', d: 'Personalized support and a long-term relationship of trust.' },
        { t: 'Exclusive Chinese Network', d: 'Privileged access to thousands of leading Chinese manufacturers.' },
      ],
    },
    team: {
      label: 'Our Team', title1: 'Meet', title2: 'the team',
      members: [
        { name: 'Denis Villeneuve', role: 'President & Founder', bio: 'Long experience in corporate financing, film and television production, international trade, and negotiation of raw materials and medical instruments.' },
        { name: 'Jimmy Changtao Yu', role: 'Vice-President & Founder', bio: 'Co-founder of Yuville, he leads the development strategy and relations with the Chinese market.' },
        { name: 'Yan Yu', role: 'Chinese Platform Director', bio: 'Manager of the platform connecting Chinese manufacturers with Canadian companies. Broad experience in sales, marketing and entrepreneurship.' },
      ],
    },
    contact: {
      label: 'Contact', title1: 'Get in', title2: 'touch',
      intro: 'A question about trading or the industrial platform? Our team can answer you in French, English or Mandarin.',
      lEmail: 'Email', lPhone: 'Phone', lOfficeCA: 'Canadian Office', lOfficeCN: 'Chinese Office',
      officeCAValue: '1155 Metcalfe, Suite 1571-2, Montréal, Québec H3B 2V6, Canada', officeCNValue: 'Shenzhen, Guangdong, China',
      viaQianyan: 'via Qianyan Holdings Group ↗',
      formTitle: 'Send us a message',
      name: 'Name', email: 'Email *', subject: 'Subject', message: 'Your message *',
      send: 'Send', sending: 'Sending…',
      missingTitle: 'Missing fields', missingDesc: 'Email and message are required.',
      sentTitle: 'Message sent', sentDesc: 'We will get back to you shortly.',
      errorTitle: 'Error', errorDesc: 'Unable to send the message.',
    },
    footer: {
      tagline: 'Canadian commodity trading company and industrial platform connected to the largest Chinese manufacturers.',
      shareholderOf: 'Shareholder of',
      services: 'Services',
      s1: 'Commodity Trading', s2: 'Trade Missions', s3: 'Partner Search', s4: 'Rescued Products', s5: 'Companies of the Month',
      company: 'Company', c1: 'About', c2: 'Qianyan Partnership', c3: 'Team', c4: 'Contact',
      rights: 'All rights reserved.',
      cities: 'Montréal, Canada · Shenzhen, China',
    },
  },

  zh: {
    nav: {
      home: '首页', about: '关于我们', trading: '贸易', platform: '工业平台',
      partnership: '合作伙伴', team: '团队', experience: '经验', contact: '联系我们',
    },
    cta: { quote: '获取报价', getInTouch: '联系我们', discover: '探索我们的服务' },
    hero: {
      badge: '国际贸易 • 自2023年',
      subtitle: '加拿大 {highlight} 公司暨工业平台，与中国最大的制造商紧密相连。我们通过两项独立的服务，为生产商、分销商和企业家提供支持。',
      highlight: '大宗商品贸易',
      service1Tag: '服务 01', service1Title: '大宗商品贸易',
      service1Desc: '查看实时行情',
      service2Tag: '服务 02', service2Title: '工业平台',
      service2Desc: '商务考察、合作伙伴、救援产品及16个类别',
      discover: '了解更多', explore: '探索',
    },
    about: {
      label: '关于我们', title1: '欢迎来到', title2: 'Yuville International inc.',
      p1: '一家专注于原材料采购和分销的加拿大贸易实体：铜、铝、黄金、沥青、硫磺、钾肥等。我们是实体贸易商，为在中国的合作伙伴和客户谈判并保障大宗数量的交易。',
      p2: '我们还是一个私人网络的成员，该网络使我们能够独家接触到中国的制造商和工业企业。寻找产品、合作伙伴以及组织商务考察是我们的专长。',
      stat1: '合作制造商', stat2: '商品类别', stat3: '交易大宗商品',
      foundedIn: '成立于 2023 年',
    },
    trading: {
      badge: '服务 01 • 贸易', title1: '大宗商品', title2: '贸易',
      intro: '铜、铝、硫磺、钾肥及其他大宗商品的生产商：加入我们的网络并提交报价。我们将您的产品与中国最大的买家连接起来。',
      whyTitle: '与 Yuville 合作',
      benefits: [
        { t: '直接进入中国市场', d: '我们的买家积极寻找优质货量，无中间商。' },
        { t: '透明的谈判', d: '公平价格、清晰合同和安全付款。' },
        { t: '物流与文件', d: '我们可以处理所有物流：检验、清关和国际运输。' },
        { t: '实体贸易商', d: '固定采购或委托采购——由您选择模式。' },
      ],
      producerBox: '您是生产商吗？',
      producerBoxDesc: '填写右侧表格以提交保密报价。我们的团队将在48小时内与您联系。',
      formTitle: '提交报价', formSubtitle: '生产商和供应商的快速注册。',
      fCompany: '公司名称 *', fCompanyPh: '您的公司名称',
      fName: '联系人姓名', fNamePh: '张三',
      fEmail: '电子邮件 *', fEmailPh: 'contact@company.com',
      fCountry: '国家', fCountryPh: '加拿大',
      fCommodity: '商品',
      fQuantity: '可供数量 *', fQuantityPh: '例如：每月5000吨',
      fMessage: '报价详情', fMessagePh: '质量、规格、贸易术语、参考价格...',
      submit: '提交报价',
      confidential: '🔒 您的信息将严格保密。',
      required: '必填字段', requiredDesc: '请填写必填字段。',
      thanksTitle: '报价已收到！', thanksDesc: '我们的团队将在48小时内与您联系。',
      errorTitle: '错误', errorDesc: '无法发送报价，请重试。',
      strongDemand: '需求强劲', stableDemand: '需求稳定', growingDemand: '需求增长',
      other: '其他',
      commodityDescs: {
        cuivre: '为全球工业提供铜阴极、精矿和铜矿石。',
        aluminium: '为制造商提供铝锭和铝合金。',
        soufre: '用于工业和农业应用的颗粒和成型硫磺。',
        potasse: '用于肥料和化学工业的氯化钾。',
        bitume: '公路级和工业级沥青。',
        or: '面向投资者和机构客户的认证金条。',
      },
      unitTonne: '美元 / 吨', unitOunce: '美元 / 盎司',
      names: { cuivre: '铜', aluminium: '铝', soufre: '硫磺', potasse: '钾肥', bitume: '沥青', or: '黄金' },
    },
    platform: {
      label: '服务 02', title1: '工业', title2: '平台',
      intro: '为希望与中国市场建立长期联系的企业家、分销商和制造商设计的五项服务。',
      services: {
        missions: {
          title: '商务考察',
          desc: '中国商务考察的全套组织：B2B会议、工厂参观、谈判及考察后跟进。',
          highlights: ['定制议程', '双语翻译', '工厂参观', '考察后跟进'],
        },
        partenaires: {
          title: '产品搜索',
          desc: '根据您的精确标准，识别并验证合格的工业合作伙伴或中国制造商。',
          highlights: ['法律验证', '质量审计', '合同谈判', '长期支持'],
        },
        rescapes: {
          title: '救援产品',
          desc: '被海关扣留、未售出或未支付的消费品，以优惠价格提供给分销商和消费者。',
          highlights: ['议价价格', '现货批次', '快速交货', '完整可追溯性'],
        },
        marchandises: {
          title: '各类商品',
          desc: '超过16类商品可供加拿大各地的分销商、零售商和批发商使用。',
          highlights: ['16个类别', '直接进口', '灵活数量', '物流支持'],
        },
        entreprises: {
          title: '本月企业',
          desc: '每月介绍两家精选的中国企业及其旗舰产品线。',
          highlights: ['月度精选', '详细档案', '直接联系', '可提供样品'],
        },
      },
      missionsHeading: '即将在中国的考察',
      missionsBook: '预订席位',
      partnersHeading: '我们的四步流程',
      partnersSteps: [
        { n: '01', t: '需求分析', d: '精确分析您的需求。' },
        { n: '02', t: '候选名单', d: '筛选合格的制造商——从产能、合规性、认证和经验四个维度评估每位候选。' },
        { n: '03', t: '实地审核', d: '工厂、产品与合规性验证——出具带证据和差距的书面报告。' },
        { n: '04', t: '合同与跟进', d: '谈判和长期支持。' },
      ],
      shortlistIntro: {
        title: '02 — 候选名单 · 筛选合格的制造商',
        p1: '根据您的需求说明书，Yuville 会研究并预筛选能够满足您要求的制造商。',
        p2: '我们评估其生产能力、对规格的符合度、认证、经验、商业条款以及服务您市场的能力。',
        p3: '随后向您呈现一份比较型候选名单，与您一起确定值得深入了解的制造商。',
      },
      auditIntro: {
        title: '03 — 实地审核 · 工厂、产品与合规性验证',
        p1: '在签订任何合同之前，我们会对入选的制造商进行深入的现场审核，核查工厂设施与生产能力、产品对您需求说明书的符合度，以及企业主要的法律与商业情况。',
        p2: '您将收到一份完整的审核报告，明确指出已验证的内容、发现的差距，以及在正式签约前需要解决的事项。',
      },
      rfq: {
        cta: '定义我的需求',
        openHint: '在此启动您的需求说明书——余下工作交给我们。',
        dialogTitle: '让我们一起定义您的需求',
        intro: '请告诉我们您正在寻找的产品、设备或工业解决方案。这些信息将帮助我们完善您的需求说明书并识别能够满足您要求的制造商。',
        s1: '1. 您的项目是什么？',
        s1Sub: '选择最能描述您需求的选项。',
        pt: {
          manufacturer: '在中国寻找制造商',
          custom: '按我的规格定制生产',
          product: '寻找现有产品',
          equipment: '寻找工业解决方案或设备',
          partner: '寻找商业或工业合作伙伴',
          other: '其他',
        },
        ptOtherLabel: '请说明您的项目',
        s2: '2. 您的需求',
        f: {
          product: '所需产品或设备',
          productPh: '例如：高压断路器、协作机器人、技术纺织品……',
          desc: '需求描述',
          descPh: '请描述背景、用途、约束条件、使用环境……',
          qty: '预估数量',
          qtyPh: '数量',
          unit: '单位',
          unitPh: '件、公斤、吨、平方米、托盘……',
          freq: '需求频率',
          budget: '预算或目标价格（可选）',
          budgetPh: '金额',
          currency: '货币',
          market: '目标市场',
          marketPh: '产品的使用或转售国家/地区',
          standards: '所需标准或认证',
          standardsPh: 'CSA、UL、CE、ISO 9001、FDA、加拿大卫生部……',
          custom: '是否需要定制？',
          customYes: '是', customNo: '否',
          customDetails: '请描述定制需求',
          customDetailsPh: '尺寸、颜色、Logo、材料、电压、包装……',
          timeline: '期望时间',
          timelinePh: '例如：希望在 2026 年 6 月前交货',
        },
        freq: {
          once: '一次性订单',
          monthly: '每月',
          quarterly: '每季度',
          yearly: '每年',
          tbd: '待定',
        },
        s3: '3. 文件与参考资料',
        s3Sub: '附上照片、图纸、报价单、技术资料或任何相关文件。',
        filesLabel: '添加文件',
        filesHint: 'PDF、DOC、XLS、图片、DWG、STEP、ZIP • 最多 8 个文件，每个不超过 15 MB',
        filesEmpty: '尚未添加文件',
        refUrl: '产品或参考链接（可选）',
        refUrlPh: 'https://…',
        s4: '4. 联系方式',
        c: {
          name: '姓名', company: '公司', role: '职位', country: '国家',
          email: '商务邮箱', phone: '电话', website: '公司网站（可选）',
        },
        submit: '提交我的需求说明书',
        submitting: '正在发送……',
        required: '必填项',
        okTitle: '您的请求已提交',
        okBody: '我们的团队将审查您提供的信息，如有需要，会先与您联系以完善需求说明书，然后再着手寻找制造商。',
        okClose: '关闭',
        errTitle: '提交出错',
        errBody: '请检查必填项后重试。',
        errFile: '不支持的文件：',
        cancel: '取消',
      },
      rescuedHeading: '本周可用批次',
      rescuedNote: '被海关扣留、未售出或未支付的商品——以优惠价格提供给分销商和消费者。',
      merchHeading: '16 个可用类别',
      merchSubtitle: '来自我们合作制造商的多样化目录。',
      companiesHeading: '本月中国企业',
      founded: '成立于',
      productCategories: [
        '电子产品','纺织品与服装','家用电器','工业工具','安全设备','家具与装饰',
        '玩具与休闲','化妆品','家居用品','汽车零部件','医疗设备','办公用品',
        '照明与LED','运动与户外','工业包装','轻型机械',
      ],
      missionsList: [
        { city: '深圳', date: '2025年11月15–22日', focus: '电子与物联网' },
        { city: '广州', date: '2026年2月10–17日', focus: '纺织与时尚' },
        { city: '上海', date: '2026年4月5–12日', focus: '工业机械' },
      ],
    },
    partnership: {
      label: '中国合作伙伴', title1: '股东', title2: '前沿控股',
      badgeLeft: '战略合作伙伴',
      subtitle: '中国深圳 · 贸易公司',
      floating1: '股东', floating2: 'Yuville International inc.',
      body: 'Yuville International inc. 荣幸地成为 {strong} 的股东，这是一家位于深圳的中国贸易公司。这一战略合作伙伴关系为我们提供了直接的中国市场立足点，以及优先接触庞大的制造商、买家和分销商网络的机会。',
      bodyStrong: '前沿控股（深圳）集团有限公司',
      benefits: [
        { t: '直接业务关系', d: '无中间人——直接与主要中国参与者谈判。' },
        { t: '深圳本地存在', d: '一支团队驻扎在中国南方工业和物流枢纽的核心。' },
        { t: '多元化投资组合', d: '大宗商品贸易、工业采购和分销。' },
      ],
      visit: '访问 qianyanholding.com',
    },
    whyUs: {
      label: '为什么选择我们', title1: '选择', title2: 'Yuville',
      intro: '我们的优势在于中国制造商的独家网络与加拿大在大宗商品贸易方面的专业知识相结合。',
      items: [
        { t: '透明卓越', d: '在所有商业交易中采取直接、诚实和透明的方式。' },
        { t: '高效采购', d: '专业快速地为客户采购难以找到的原材料。' },
        { t: '可靠合作伙伴', d: '个性化支持和长期信任关系。' },
        { t: '独家中国网络', d: '优先接触数千家中国行业领先制造商。' },
      ],
    },
    team: {
      label: '我们的团队', title1: '认识', title2: '团队',
      members: [
        { name: 'Denis Villeneuve', role: '总裁兼创始人', bio: '在企业融资、电影电视制作、国际贸易以及原材料和医疗器械谈判方面拥有丰富经验。' },
        { name: 'Jimmy Changtao Yu', role: '副总裁兼创始人', bio: 'Yuville 的联合创始人，负责发展战略以及与中国市场的关系。' },
        { name: 'Yan Yu', role: '中国平台总监', bio: '连接中国制造商与加拿大企业的平台经理。在销售、营销和创业方面拥有丰富经验。' },
      ],
    },
    contact: {
      label: '联系', title1: '与我们', title2: '取得联系',
      intro: '有关贸易或工业平台的问题？我们的团队可以用法语、英语或中文回复您。',
      lEmail: '电子邮件', lPhone: '电话', lOfficeCA: '加拿大办公室', lOfficeCN: '中国办公室',
      officeCAValue: '加拿大魁北克蒙特利尔 Metcalfe 1155 号 1571-2 室 H3B 2V6', officeCNValue: '中国广东深圳',
      viaQianyan: '通过 前沿控股集团 ↗',
      formTitle: '给我们发消息',
      name: '姓名', email: '电子邮件 *', subject: '主题', message: '您的消息 *',
      send: '发送', sending: '发送中…',
      missingTitle: '缺少字段', missingDesc: '电子邮件和消息是必填项。',
      sentTitle: '消息已发送', sentDesc: '我们将尽快回复您。',
      errorTitle: '错误', errorDesc: '无法发送消息。',
    },
    footer: {
      tagline: '与中国最大的制造商相连的加拿大大宗商品贸易公司暨工业平台。',
      shareholderOf: '股东',
      services: '服务',
      s1: '大宗商品贸易', s2: '商务考察', s3: '寻找合作伙伴', s4: '救援产品', s5: '本月企业',
      company: '公司', c1: '关于我们', c2: '前沿合作伙伴', c3: '团队', c4: '联系',
      rights: '版权所有。',
      cities: '加拿大蒙特利尔 · 中国深圳',
    },
  },
};
